/**
 * WineNot — Cambio de mercado por geolocalización
 * Usa el componente nativo de localización del tema Craft
 */

(function () {

  if (window.Shopify && window.Shopify.designMode) return;

  const COUNTRY_MARKETS = {
    'MX': 'MX',
    'CO': 'CO',
    'PE': 'PE',
    'GT': 'GT',
    'US': 'US',
  };

  const CACHE_MINUTES = 60;

  function getCookie(name) {
    const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? match[2] : null;
  }

  function setCookie(name, value, minutes) {
    const expires = new Date(Date.now() + minutes * 60 * 1000).toUTCString();
    document.cookie = name + '=' + value + '; expires=' + expires + '; path=/; SameSite=Lax';
  }

  function switchMarket(countryCode) {
    // Buscar el select de país nativo del tema
    const countrySelects = document.querySelectorAll('select[name="country_code"]');
    
    if (countrySelects.length === 0) {
      console.warn('WineNot: no se encontró el selector de país');
      return;
    }

    // Usar el primer select encontrado
    const select = countrySelects[0];
    
    // Verificar que la opción existe
    const option = select.querySelector(`option[value="${countryCode}"]`);
    if (!option) {
      console.warn('WineNot: país no encontrado en el selector:', countryCode);
      return;
    }

    // Cambiar el valor y disparar el evento change nativo
    select.value = countryCode;
    select.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function geoRedirect() {
    if (getCookie('wn_switched')) return;

    fetch('/browsing_context_suggestions.json')
      .then(function(res) { return res.json(); })
      .then(function(data) {
        const country = data &&
          data.detected_values &&
          data.detected_values.country &&
          data.detected_values.country.handle
          ? data.detected_values.country.handle.toUpperCase()
          : null;

        if (!country) return;

        setCookie('wn_country', country, CACHE_MINUTES);

        const currentCountry = window.Shopify && window.Shopify.country
          ? window.Shopify.country.toUpperCase()
          : null;

        const targetCountry = COUNTRY_MARKETS[country];

        if (targetCountry && currentCountry && targetCountry !== currentCountry) {
          setCookie('wn_switched', '1', CACHE_MINUTES);
          switchMarket(targetCountry);
        }
      })
      .catch(function() {});
  }

  // Esperar a que el DOM esté completamente cargado
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', geoRedirect);
  } else {
    geoRedirect();
  }

})();